"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueByPath = getValueByPath;
exports.walkInPath = walkInPath;
// This is generated source code DO NOT MODIFY here but in mf-fields/typescript directory
function getValueByPath(source, path) {
    return path
        .replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
        .split('.')
        .reduce((nestedSource, part) => getValue(nestedSource, part), source);
}
function getValue(nestedSource, part) {
    if (nestedSource === undefined) {
        return nestedSource;
    }
    if (!nestedSource.hasOwnProperty(part)) {
        return undefined;
    }
    return nestedSource[part];
}
const walkUpExpression = /\.\.\//g;
function walkInPath(absolutePath, relativePath) {
    const walkUps = (relativePath.match(walkUpExpression) || []).length;
    const parts = absolutePath.split('.');
    return parts.slice(0, parts.length - walkUps).join(".") + "." + relativePath.replace(walkUpExpression, '');
}
